import { useAppDispatch, useAppSelector } from "@app/store";
import { useCallback } from "react";
import { changeAdminCache, createAdminCache, getAdminCaches } from "./slice";
import { CreateCacheRequest } from "./api";

export const useAdminCaches = () => {
  const state = useAppSelector((state) => state.adminCaches);
  const dispatch = useAppDispatch();

  const getAdminCachesHandler = useCallback(
    (userId: string) => dispatch(getAdminCaches({ userId })),
    [dispatch]
  );
  const createAdminCacheHandler = useCallback(
    (userId: string, data?: CreateCacheRequest) =>
      dispatch(createAdminCache({ userId, data })),
    [dispatch]
  );
  const changeAdminCacheHandler = useCallback(
    (cacheId: string) => dispatch(changeAdminCache({ cacheId })),
    [dispatch]
  );

  return {
    state,
    getAdminCaches: getAdminCachesHandler,
    createAdminCache: createAdminCacheHandler,
    changeAdminCache: changeAdminCacheHandler,
  };
};
